import * as variablesHelpers from 'components/MCTextEditor/variables/helpers'
import { MessengerMessageTemplateDraft } from 'shared/api/requests/messenger/schemas'

export enum MessengerMessageTemplatesSections {
  HEADER = 'Header',
  BODY = 'Body',
  BUTTON = 'URL Button',
}

interface ReturnValue {
  variables: string[]
  variablesMap: Map<MessengerMessageTemplatesSections, string[]>
}

export const extractVariablesFromMessageTemplate = (
  messageTemplate: MessengerMessageTemplateDraft | null,
): ReturnValue => {
  if (!messageTemplate) return { variables: [], variablesMap: new Map() }

  const { body = '', buttons, header } = messageTemplate
  const bodyVariables = variablesHelpers.extractVariables(body)
  const result = new Set<string>(bodyVariables)
  const variablesMap = new Map<MessengerMessageTemplatesSections, string[]>()

  if (!Array.isArray(header) && header && header.text) {
    const headerVariables = variablesHelpers.extractVariables(header.text)
    headerVariables.forEach((variable) => result.add(variable))
    if (headerVariables.length)
      variablesMap.set(MessengerMessageTemplatesSections.HEADER, headerVariables)
  }

  if (bodyVariables.length) variablesMap.set(MessengerMessageTemplatesSections.BODY, bodyVariables)

  const urlButton = buttons?.find((button) => button.type === 'URL')

  if (urlButton?.type === 'URL' && urlButton.variable) {
    if (urlButton.variable.length)
      variablesMap.set(MessengerMessageTemplatesSections.BUTTON, [urlButton.variable])

    result.add(urlButton?.variable)
  }

  return { variables: Array.from(result), variablesMap }
}
